// HR reports API calls. API only: these return data (or null on error) and never dispatch;
// the page dispatches to Redux after they resolve.
import { toast } from "react-toastify";
import { HrReportRow, HrRetentionReport } from "models/hr-reports";

const API = `${process.env.REACT_APP_API_URL}/hr-reports`;

const getJson = async <T>(url: string, fallback: string): Promise<T | null> => {
    try {
        const res = await fetch(url, { credentials: "include" });
        const body = await res.json().catch(() => null);
        if (!res.ok) throw new Error(body?.message ?? fallback);
        return body.data as T;
    } catch (err: any) {
        toast.error(err.message ?? fallback);
        return null;
    }
};

export const getDemographicsReport = () =>
    getJson<HrReportRow[]>(`${API}/demographics`, "Unable to load demographics.");

export const getAnniversaryReport = () =>
    getJson<HrReportRow[]>(`${API}/anniversary`, "Unable to load anniversaries.");

export const getRetentionReport = (fiscalYear: number) =>
    getJson<HrRetentionReport>(`${API}/retention?fy=${fiscalYear}`, "Unable to load retention.");
